module.exports = __webpack_public_path__ + "static/img/musictmp.594798de.jpg";